// extracted by mini-css-extract-plugin
export default {"calculateEventSection":"calculateEvent_calculateEventSection__Sw8y4"};